// extracted by mini-css-extract-plugin
export default {"active":"Navlink_active__PtTfK"};